/**
 * For lists paged, sorted and searched on the server: converts the grid's list state into
 * the body of a POST /v1/<area>/list request, and list responses ({ items, total }) into
 * { rows, total } for AdminDataGrid's rows and rowCount. paginationModel and sortModel are
 * the MUI DataGrid models; filters is { [name]: value }. search is only sent when set, and
 * only once that area's backend list endpoint supports it.
 */
export const toListRequestBody = ({ paginationModel, sortModel, filters, search }) => ({
	page: paginationModel.page,
	pageSize: paginationModel.pageSize,
	...(search && { search }),
	...(sortModel[0] && { sort: { field: sortModel[0].field, direction: sortModel[0].sort } }),
	filters,
});

export const fromListResponse = (response) => ({
	rows: response.items,
	total: response.total,
});
